import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Button, IconButton, TextareaAutosize } from '@mui/material';
import { FC } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';

import { IComment } from '../../../store/review/review.interface';
import CheckoutField from '../../form-elements/CheckoutField/CheckoutField';

import styles from './Comment.module.sass';
import { useCommentForm } from './useCommentForm';

const CommentForm: FC = () => {
  const form = useForm<IComment>({
    mode: 'onChange',
  });
  const { onShowComments, formSubmitted, onSubmit, inputRef } =
    useCommentForm(form);
  return (
    <>
      {formSubmitted ? (
        <></>
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className={styles.form}>
            <div className={styles.wrapper}>
              <Controller
                control={form.control}
                name="content"
                render={({ field: { onChange, value } }) => {
                  return (
                    <TextareaAutosize
                      onChange={onChange}
                      value={value}
                      ref={inputRef}
                      className={styles.textarea}
                      placeholder="Написать комментарий..."
                    />
                  );
                }}
              />

              <div className={styles.button}>
                <Button
                  variant="orange"
                  className={styles.button}
                  type="submit"
                  onClick={onShowComments}
                >
                  Отправить
                </Button>
              </div>
            </div>
          </form>
        </FormProvider>
      )}
    </>
  );
};

export default CommentForm;
